'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgTimer(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 2a6 6 0 110 12A6 6 0 018 2zM5.087 6.035l1.907 2.833c.4.597 1.129.706 1.639.204.502-.525.4-1.253-.197-1.653l-2.825-1.9c-.408-.27-.787.116-.524.516z", fill: "currentColor" }))));
}

module.exports = SvgTimer;
//# sourceMappingURL=Timer.js.map
